

















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { StoreModel, Pdi, VehicleLocation } from '@/models/admin/store';
import { Base } from '@/components/common/base';
import { storeService } from '@/shared';
import { ValidationRules } from '@/helper/enum';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class SaveStoreVehicleLocationPage extends Base {
  public storeViewModel: any = {};
  public storeModel: StoreModel = {};

  public vehicleModel: VehicleLocation = {
    id: '',
    locationName: '',
    storeName: '',
    isDefault: false
  };
  public form: any = {};
  public storeVehicleLocationFields: Array<VFields<any>> = [];
  public storeId: number = 0;
  public tenantId: number = 0;
  public enterpriseId: number = 0;
  public requestProgress: boolean = false;

  public callMethod(methodName): void {
    if (methodName === 'backToStoreEdit') {
      this.$router
        .push({
          name: 'admin.stores.edit',
          params: { id: this.storeId.toString(), tab: 'Location' },
        })
        .catch((ex) => { console.log(ex); });
    } else if (methodName === 'submit') {
      if (!this.form.$valid) {
        this.showAlert(
          false,
          this.$t('stores.vehicleLocations.alertInvalidForm')
        );
        this.resetMethodName(methodName);
        return;
      }
      this.saveStoreVehiclLocation();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    if (this.storeId) {
      buttons.push({
        id: '0',
        type: 'button',
        title: this.$parent.$t('stores.btnBackToStoreTitle'),
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$parent.$t('stores.btnBack'),
        click: 'backToStoreEdit',
        icon: 'fas fa-arrow-left',
      });
    }
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    this.setLocationFields();
    if (this.$route.params.storeId) {
      this.storeId = Number(this.$route.params.storeId);
      this.getStoreInfo();
    }

    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
  }
  public setLocationFields(): void {
    this.storeVehicleLocationFields = [
      {
        key: 'storeName',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: true,
          required: false,
          label: this.$t(
            'stores.vehicleLocations.locationsFields.storeName'
          ) as string,
          counter: 30,
          loading: false,
        },
      },
      {
        key: 'locationName',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: true,
          label: this.$t(
            'stores.vehicleLocations.locationsFields.locationName'
          ) as string,
          counter: 10,
          loading: false,
          rules: [
            v => this.required('Location Name', v)
          ]
        },
      },
      {
        key: 'isDefault',
        type: 'v-alynk-switch',
        required: false,
        templateOptions: {
          label: 'Default Location',
          disabled: false,
          validations: '',
          loading: false,
        },
      },
    ];
  }

  public validateStoreVehicleLocation(): Vue & { validate: () => boolean } {
    return this.$refs.vehicleLocationForm as Vue & { validate: () => boolean };
  }

  public async saveStoreVehiclLocation(): Promise<void> {
    if (this.validateStoreVehicleLocation().validate()) {
      try {
        this.requestProgress = true;
        this.$emit('update:progress', this.requestProgress);
        if (this.vehicleModel.id === '') {
          await storeService.saveLocation(this.storeId, this.vehicleModel);
          this.showAlert(
            true,
            this.$t('stores.vehicleLocations.alertVehicleLocationAdded')
          );
          this.$router
            .push({
              name: 'admin.stores.edit',
              params: {
                tenantId: this.tenantId.toString(),
                enterpriseId: this.enterpriseId.toString(),
                storeId: this.storeId.toString(),
                tab: 'Location'
              },
            })
            .catch((ex) => { console.log(ex); });
        } else {
          await storeService.updateLocation(this.storeId, this.vehicleModel);
          const locations = this.storeViewModel.storeJson.vehicleLocations || [];
          const vehicleExists = locations.find((n) => {
            return n.id === this.$route.params.locationId;
          });
          if (vehicleExists) {
            vehicleExists.locationName = this.vehicleModel.locationName;
            vehicleExists.isDefault = this.vehicleModel.isDefault;
          }

          this.showAlert(
            true,
            this.$t('stores.vehicleLocations.alertVehicleLocationUpdated')
          );
          this.$router
            .push({
              name: 'admin.stores.edit',
              params: {
                tenantId: this.tenantId.toString(),
                enterpriseId: this.enterpriseId.toString(),
                storeId: this.storeId.toString(),
                tab: 'Location'
              },
            })
            .catch((ex) => { console.log(ex); });
        }
      } finally {
        this.requestProgress = false;
        this.$emit('update:progress', this.requestProgress);
      }
    }
  }

  public async getStoreInfo(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.storeVehicleLocationFields);
      const response = await storeService.getStore(this.storeId);
      this.storeViewModel = response;
      this.storeModel.id = this.storeViewModel.id;
      this.storeModel.storeJson = this.storeViewModel.storeJson;
      this.vehicleModel.storeName = this.storeViewModel.storeJson.name;
      this.vehicleModel.storeId = this.storeViewModel.id;

      if (this.$route.params.locationId) {
        const locations = this.storeViewModel.storeJson.vehicleLocations || [];
        const vehicleExists = locations.find((n) => {
          return n.id === this.$route.params.locationId;
        });
        if (vehicleExists) {
          this.vehicleModel = {
            id: vehicleExists.id,
            locationName: vehicleExists.locationName,
            isDefault: vehicleExists.isDefault,
            storeId: this.storeModel.id,
            storeName: this.storeViewModel.storeJson.name,
          };
        }
      }
    } finally {
      this.formlyHideSkeleton(this.storeVehicleLocationFields);
    }
  }
}
